// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_26zTT","visuallyhidden":"_3mhAw","hide-text":"_1TwGW","center":"_3OgY9","noprint":"_1Erft","root":"_2jcqS","item":"Y1aUW"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-list/styles/List.scss
 ** module id = 340
 ** module chunks = 1
 **/